import { subscribePricePlansEvent } from "@discovery/common-dplus/lib/adobe";
import { useEffect, useGlobalState, useState, } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useWindowSize } from "../../utils/hooks";
import { Button, ButtonVariant } from "../../components/atoms/button";
import { HeaderVariants, Tags, Typography, } from "../../components/atoms/typography";
import { navigateTo } from "../../utils/common";
import { ButtonContainer, FloatingPlanPicker, MobileContainer, PlanWrapper, PlanWrappers, PremiumContainer, PricePlanContainer, SaveRecommendWrapper, UiWrap, Wrapper, } from "./index.styled";
export const MobilePlansView = ({ pricePlans, preferredPricePlan, read, isDefault, }) => {
    const [width] = useWindowSize();
    const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
    const [defaultPlan, setDefaultPlans] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState("");
    const [selectedPeriod, setSelectedPeriod] = useState("");
    const [defaultPlanId, setDefaultPlanId] = useState("");
    const [userM] = useGlobalState(_user);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    const setDefaultPlan = (pricePlans) => {
        pricePlans.map((item) => {
            return setDefaultPlanId(item.period === "YEAR" ? item.id : "");
        });
        return;
    };
    useEffect(() => {
        setDefaultPlan(pricePlans);
    }, [pricePlans]); //eslint-disable-line react-hooks/exhaustive-deps
    const addDecimalPoint = (price, decimalPoint) => {
        const value = price / Math.pow(10, decimalPoint);
        return value.toFixed(2);
    };
    const renderLabelBasedOnPeriod = (type) => {
        switch (type) {
            case "DAY":
                return "One day";
            case "INFINITE":
                return "Lifetime";
            case "MONTH":
                return "Monthly";
            case "WEEK":
                return "Weekly";
            case "YEAR":
                return "Annual";
            default:
                return;
        }
    };
    const onButtonPress = (item) => {
        setDefaultPlans(false);
        setSelectedIndex(item.id);
        setSelectedPeriod(item.period);
    };
    const View = ({ item, preferredPricePlan, }) => {
        const price = addDecimalPoint(item.price, item.currencyDecimalPoints);
        const planLabel = renderLabelBasedOnPeriod(item.period);
        const isRecommended = preferredPricePlanId === item.id;
        const isPlanActive = defaultPlan
            ? isRecommended
            : selectedIndex === item.id;
        return (React.createElement(MobileContainer, { id: "#pricePlan" + item.period, isPlanActive: isPlanActive },
            React.createElement("div", { onClick: () => onButtonPress(item), id: "#scrollDemo" },
                React.createElement(UiWrap, { id: "uiWrap" },
                    isRecommended && (React.createElement(RenderMaybe, null, M.map((label) => (React.createElement(SaveRecommendWrapper, { isPlanActive: false },
                        React.createElement(Typography, { classNameM: M.of("recommended"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                            React.createElement(React.Fragment, null, label.toUpperCase())))), preferredPricePlan.label))),
                    React.createElement(FloatingPlanPicker, { id: "floating" },
                        React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                            React.createElement(React.Fragment, null, planLabel)),
                        React.createElement(PremiumContainer, null,
                            React.createElement("span", { className: isPlanActive ? "active" : "inactive" }, "\u20B9"),
                            React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                                React.createElement(React.Fragment, null, price))))))));
    };
    const logBranchAdsEventForPurchase = (priceId, period) => {
        const event_and_custom_data = {
            content_id: priceId,
            name: `${"DiscoveryPlus Main" + " " + period}`,
        };
        try {
            branch &&
                branch.logEvent("PURCHASE", event_and_custom_data, function (err) {
                    console.info(err);
                });
        }
        catch (e) {
            console.info(e);
        }
    };
    const onPressContinue = () => {
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isPlanSelected = preferredPricePlanId === defaultPlanId || selectedIndex !== "";
        if (isPlanSelected) {
            const selectedId = defaultPlan ? defaultPlanId : selectedIndex;
            const selectedPriceId = defaultPlan ? defaultPlanId : selectedIndex;
            const selectedPricePeriodForAdobe = defaultPlan ? "YEAR" : selectedPeriod;
            subscribePricePlansEvent(selectedPriceId, selectedPricePeriodForAdobe, isAnonymous, userType, userId);
            logBranchAdsEventForPurchase(selectedPriceId, defaultPlan ? "ANNUAL" : selectedPeriod);
            const protocol = read.authService.protocol;
            const domain = read.authService.domain;
            const premiumReturnURL = window.location.origin + "/premium";
            const url = protocol +
                "://" +
                domain +
                `/login?flow=purchase&header=premiumShow&passId=${selectedId}`;
            navigateTo(`${url}&returnUrl=${premiumReturnURL}`);
        }
    };
    const ContinueBtn = ({ isFloatingBtn }) => {
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isPlanSelected = preferredPricePlanId === defaultPlanId || selectedIndex !== "";
        return (React.createElement(ButtonContainer, { isFloatingBtn: isFloatingBtn },
            React.createElement(Button, { customstyle: "subscribe", children: "Subscribe Now", variant: isPlanSelected ? ButtonVariant.Primary : ButtonVariant.Disabled, onClickM: M.of(() => {
                    onPressContinue();
                }), id: "#subscribeButton" })));
    };
    const PlansView = ({ item }) => {
        const price = addDecimalPoint(item.price, item.currencyDecimalPoints);
        const planLabel = renderLabelBasedOnPeriod(item.period);
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isRecommended = preferredPricePlanId === item.id;
        const isPlanActive = defaultPlan
            ? isRecommended
            : selectedIndex === item.id;
        return (React.createElement(PricePlanContainer, { onClick: () => onButtonPress(item), id: "#pricePlan" + item.period, isPlanActive: isPlanActive },
            React.createElement(UiWrap, null,
                isRecommended && (React.createElement(RenderMaybe, null, M.map((label) => (React.createElement(SaveRecommendWrapper, { isPlanActive: false },
                    React.createElement(Typography, { classNameM: M.of("recommended"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, label.toUpperCase())))), preferredPricePlan.label))),
                React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, planLabel)),
                React.createElement(PremiumContainer, null,
                    React.createElement("span", { className: isPlanActive ? "active" : "inactive" }, "\u20B9"),
                    React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, price))),
                React.createElement(RenderMaybe, null, M.map((subTitle) => (React.createElement(SaveRecommendWrapper, { isSave: true, isPlanActive: isPlanActive },
                    React.createElement(Typography, { classNameM: M.of("save"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, subTitle)))), item.secondaryTitleM)))));
    };
    const MobilePlan = () => {
        return (React.createElement("div", null,
            React.createElement(Wrapper, null, pricePlans.map((item) => {
                return React.createElement(View, { item: item, preferredPricePlan: preferredPricePlan });
            })),
            width <= 699 && React.createElement(ContinueBtn, { isFloatingBtn: true })));
    };
    const Plans = () => {
        return (React.createElement("div", null,
            React.createElement(Wrapper, null, pricePlans.map((item) => (React.createElement(PlansView, { item: item })))),
            width <= 1023 && (React.createElement(PlanWrappers, null,
                React.createElement(ContinueBtn, null)))));
    };
    return React.createElement(PlanWrapper, null, isDefault ? React.createElement(Plans, null) : React.createElement(MobilePlan, null));
};

